import { BookOpen, Compass } from "lucide-react";

type PathItem = {
  title: string;
  chapter: string;
  accent: string;
  dot: string;
};

const lessonPath: PathItem[] = [
  { title: "Needs vs Wants", chapter: "Money", accent: "from-cyan-400/25 to-cyan-400/0", dot: "bg-cyan-400" },
  { title: "Delayed Gratification", chapter: "Behavior", accent: "from-indigo-400/25 to-indigo-400/0", dot: "bg-indigo-400" },
  { title: "Cash Flow", chapter: "Business", accent: "from-emerald-400/25 to-emerald-400/0", dot: "bg-emerald-400" },
  { title: "Opportunity Cost", chapter: "Economics", accent: "from-violet-400/25 to-violet-400/0", dot: "bg-violet-400" },
];

const ProductPreviewsSection = () => (
  <section className="relative py-16 sm:py-20">
    <div className="container mx-auto px-6 max-w-6xl">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5 mb-8">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.3em] text-cyan-300/90 mb-4">
            <span className="h-1.5 w-1.5 rounded-full bg-cyan-400 shadow-[0_0_10px_rgba(34,211,238,0.95)]" />
            Built for practical decisions
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl md:text-[2.6rem] text-white leading-[1.05]">
            Economic &amp; Enterprise Education{" "}
            <span className="bg-gradient-to-r from-cyan-200 via-indigo-200 to-violet-200 bg-clip-text text-transparent">that adapts to how teens learn.</span>
          </h2>
          <p className="mt-3 text-white/65 leading-relaxed">
            HeirWise turns money, economics, business, and entrepreneurship into practical decisions teens can understand, practice, and apply.
          </p>
        </div>
      </div>

      {/* Illustrative learning sequence — examples, not a curriculum inventory. */}
      <div className="relative rounded-3xl p-[1px] bg-gradient-to-r from-cyan-400/25 via-indigo-500/25 to-violet-500/25">
        <div className="relative rounded-3xl bg-[#0e0d24]/80 backdrop-blur-xl p-5 sm:p-6 overflow-hidden">
          <div className="flex items-center justify-between mb-4">
            <div className="text-[10px] uppercase tracking-[0.3em] text-white/55">Example learning path</div>
            <div className="text-[10px] uppercase tracking-[0.3em] text-cyan-300/80 flex items-center gap-1.5">
              <Compass className="h-3 w-3" /> Adaptive guidance
            </div>
          </div>

          <div className="grid gap-2.5 grid-cols-2 md:grid-cols-4">
            {lessonPath.map((l, i) => {
              return (
                <div
                  key={l.title}
                  className="group relative rounded-xl border border-white/10 bg-[#13122e]/85 backdrop-blur-md p-3 transition-all hover:border-cyan-300/40"
                >
                  <div aria-hidden className={`pointer-events-none absolute -top-6 -right-6 h-20 w-20 rounded-full bg-gradient-to-br ${l.accent} blur-2xl opacity-70`} />
                  <div className="relative flex items-center gap-2 mb-1.5">
                    <span className={`h-1.5 w-1.5 rounded-full ${l.dot} shadow-[0_0_10px_rgba(255,255,255,0.5)]`} />
                    <span className="text-[9px] uppercase tracking-[0.22em] text-white/45 font-heading">{String(i + 1).padStart(2, "0")}</span>
                    <span className="text-[9px] uppercase tracking-[0.2em] text-white/40 ml-auto truncate">{l.chapter}</span>
                  </div>
                  <div className="relative flex items-start gap-2">
                    <BookOpen className="h-3.5 w-3.5 text-white/70 shrink-0 mt-0.5" />
                    <div className="text-[12.5px] text-white font-medium leading-snug">{l.title}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default ProductPreviewsSection;